import React from "react";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";
import { StaffFormValues } from "../StaffForm";
import { useLocations } from "@/hooks/useLocations";

interface LocationFieldProps {
  form: UseFormReturn<StaffFormValues>;
}

const LocationField: React.FC<LocationFieldProps> = ({ form }) => {
  const { data: locationsData, isLoading } = useLocations();
  const locations = locationsData?.data || [];
  const hasMultipleLocations = locations.length > 0; // Show even with one location

  // Only hide if there are no locations
  if (!hasMultipleLocations && isLoading) {
    return null;
  }

  const handleLocationChange = (value: string) => {
    // Always set the exact value, including "none" (don't convert to null)
    form.setValue('location_id', value);
  };

  return (
    <FormField
      control={form.control}
      name="location_id"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Location</FormLabel>
          <Select
            disabled={isLoading}
            onValueChange={handleLocationChange}
            value={field.value || "none"}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select a location" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="none">None</SelectItem>
              {locations.map((location) => (
                <SelectItem key={location.id} value={location.id}>
                  {location.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default LocationField; 